/** Adds a media query change listener, falling back to the deprecated `addListener` API on older browsers (Safari < 14). */
export const addMediaQueryListener = (query: MediaQueryList, handler: () => void): void => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (query.addEventListener) {
		query.addEventListener('change', handler);
	} else {
		query.addListener(handler);
	}
};

/** Removes a media query change listener, falling back to the deprecated `removeListener` API on older browsers (Safari < 14). */
export const removeMediaQueryListener = (query: MediaQueryList, handler: () => void): void => {
	// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
	if (query.removeEventListener) {
		query.removeEventListener('change', handler);
	} else {
		query.removeListener(handler);
	}
};
